import CryptoJS from 'crypto-js';
import { saveAs } from 'file-saver';

/**
 * @description: 获取文件唯一标识
 * @return {*}
 */
export const calculateFileId = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const chunkSize = 2097152; // 2MB chunks
        const fileReader = new FileReader();
        let currentChunk = 0;
        const chunks = Math.ceil(file.size / chunkSize);

        // 为SHA256创建一个状态保持机制
        let hasher = CryptoJS.algo.SHA256.create(); // 如果CryptoJS支持的话

        const loadNextChunk = () => {
            const start = currentChunk * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);

            fileReader.onload = (e) => {
                if (!e?.target?.result) {
                    return reject('文件读取失败')
                }
                const wordArray = CryptoJS.lib.WordArray.create(e?.target?.result as ArrayBuffer);
                // 将当前块添加到哈希器中
                hasher.update(wordArray);
                currentChunk++;
                if (currentChunk < chunks) {
                    loadNextChunk();
                } else {
                    // 完成最终哈希计算
                    const hash = hasher.finalize().toString();
                    resolve(hash);
                }
            };
            fileReader.onerror = reject;
            fileReader.readAsArrayBuffer(chunk);
        };
        loadNextChunk();
    });
}

// 获取字符串唯一标识
export const calculateStringId = (str: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        try {
            // 为SHA256创建一个状态保持机制
            const hash = CryptoJS.SHA256(str);
            const hashStr = hash.toString()
            resolve(hashStr)
        } catch (error) {
            reject(error)
        }
    });
}

/**
 * @description: 获取文件类型
 * @param {string} filename
 * @return {*}
 */
export const getFileType = (filename: string) => {
    const ext = filename.split('.').pop()?.toLowerCase();
    return ext || ''
};

/**
 * @description: blob转file
 * @param {object} param1
 * @return {*}
 */
export const blobToFile = ({ blob, fileType }: { blob: Blob, fileType: string }): File => {
    const fileName = 'file' + '.' + fileType;
    return new File([blob], fileName, { type: fileType });
};

export const download = async ({ request, fileName }: {
    request: any;
    fileName: string;
}) => {
    const res = await request()
    saveAs(res?.data, fileName)
};